import i18n from "./i18n";
import { setStoqqyLang } from ".";
import { Menu, MenuItem, Grid } from "@material-ui/core";
import { useState } from "react";
import english from "../assets/english.png";
import italian from "../assets/italian.png";
import german from "../assets/german.png";
import french from "../assets/french.png";
import spanish from "../assets/spanish.png";

export default function LanguageMenu() {
  const changeLanguage = (key) => {
    setStoqqyLang(key);
    i18n.changeLanguage(key);
    handleClose();
    window.location.reload(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableAutoFocusItem
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        MenuListProps={{
          "aria-labelledby": "lock-button",
          role: "listbox",
        }}
      >
        <MenuItem
          onClick={handleClose}
          key="en"
          disabled={i18n.language === "en"}
          onClick={() => {
            changeLanguage("en");
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Overpass",
              fontSize: "14px",
              width: "100px",
            }}
          >
            <Grid style={{ width: "60px" }}>English</Grid>
            <img
              src={english}
              alt="it"
              width="30px"
              height="20px"
              style={{ paddingLeft: "10px", cursor: "pointer" }}
            />
          </Grid>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          key="fr"
          disabled={i18n.language === "fr"}
          onClick={() => {
            changeLanguage("fr");
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Overpass",
              fontSize: "14px",
              width: "100px",
            }}
          >
            <Grid style={{ width: "60px" }}>French</Grid>
            <img
              src={french}
              alt="it"
              width="30px"
              height="20px"
              style={{ paddingLeft: "10px", cursor: "pointer" }}
            />
          </Grid>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          key="de"
          disabled={i18n.language === "de"}
          onClick={() => {
            changeLanguage("de");
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Overpass",
              fontSize: "14px",
              width: "100px",
            }}
          >
            <Grid style={{ width: "60px" }}>German</Grid>
            <img
              src={german}
              alt="it"
              width="30px"
              height="20px"
              style={{ paddingLeft: "10px", cursor: "pointer" }}
            />
          </Grid>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          key="it"
          disabled={i18n.language === "it"}
          onClick={() => {
            changeLanguage("it");
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Overpass",
              fontSize: "14px",
              width: "100px",
            }}
          >
            <Grid style={{ width: "60px" }}>Italian</Grid>
            <img
              src={italian}
              alt="it"
              width="30px"
              height="20px"
              style={{ paddingLeft: "10px", cursor: "pointer" }}
            />
          </Grid>
        </MenuItem>
        <MenuItem
          onClick={handleClose}
          key="es"
          disabled={i18n.language === "es"}
          onClick={() => {
            changeLanguage("es");
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              fontFamily: "Overpass",
              fontSize: "14px",
              width: "100px",
            }}
          >
            <Grid style={{ width: "60px" }}>Spanish</Grid>
            <img
              src={spanish}
              alt="it"
              width="30px"
              height="20px"
              style={{ paddingLeft: "10px", cursor: "pointer" }}
            />
          </Grid>
        </MenuItem>
      </Menu>
      <img
        src={
          i18n.language === "it"
            ? italian
            : i18n.language === "fr"
            ? french
            : i18n.language === "de"
            ? german
            : i18n.language === "es"
            ? spanish
            : english
        }
        alt="it"
        width="30px"
        height="20px"
        style={{ paddingRight: "20px", cursor: "pointer" }}
        onClick={handleClick}
      ></img>
    </>
  );
}
